module.exports = __webpack_public_path__ + "img/vertical_2_1_3016.2befaef5.png";